import { useMutation } from "@tanstack/react-query";

import { CONSOLE_API_ROUTES } from "@/config/apiConfig";
import consoleAxios from "@/service/axios/consoleAxios";

interface body {
    idx: (number | string)[];
    b_open: string;
    category: number;
}

// 게시글 노출 상태 변경
export const usePostBoardState = () => {
    return useMutation({
        mutationFn: async (body: body) => {
            const res = await consoleAxios.post(CONSOLE_API_ROUTES.BOARD_STATE, body);
            return res.data;
        },
    });
};
